var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2666 0C8.86657 0 9.41679 0.324857 9.7168 0.841471L10.1831 1.65039C10.5413 2.28369 10.608 3.05046 10.3581 3.73372L9.74202 5.41667H13.3333C14.4249 5.41667 15.2245 6.45805 14.9414 7.51628L13.2666 13.7663C13.075 14.4912 12.4168 14.9999 11.6585 15H1.66667C0.75 15 0 14.25 0 13.3333V7.08333C0 6.16667 0.75 5.41667 1.66667 5.41667H3.70036C4.00016 5.41654 4.27468 5.25814 4.42464 5L6.82536 0.833333C7.13369 0.308448 7.66669 2.23229e-05 8.2666 0ZM2.5 7.08333C2.04167 7.08333 1.66667 7.45833 1.66667 7.91667V12.5C1.66667 12.9583 2.04167 13.3333 2.5 13.3333H4.10807V7.08333H2.5ZM5.625 6.25V13.3333H11.0164L11.0254 13.3252C11.4086 13.325 11.7335 13.0749 11.8335 12.7083L13.0583 8.125C13.1999 7.59172 12.8001 7.0753 12.2502 7.0752H8.5498C7.96665 7.07507 7.56712 6.50021 7.76693 5.95866L8.78337 3.17464C8.86654 2.94143 8.84152 2.67504 8.71663 2.4585L8.25846 1.66667L5.625 6.25Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIconNew);
export default __webpack_public_path__ + "static/media/like-icon-new.bfb67bf835541665fb54f0060262d73c.svg";
export { ForwardRef as ReactComponent };